export default "__VITE_ASSET__DF2J2fvk__"